<template>
  <div v-frag>
    <CardIeaAppMain colorCard="#2D3436" title="">
      <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="12">
        <v-btn
          class="mx-2"
          fab
          dark
          small
          color="success"
          @click="$router.go(-1)"
        >
          <v-icon dark>
            mdi-keyboard-backspace
          </v-icon>
        </v-btn>
        <br /><br />

        <div
          class="text-xs-h4 text-sm-h4 text-md-h4 text-lg-h4 text-xl-h4 primary-text"
        >
           <div
            class="text-xs-h4 text-sm-h4 text-md-h4 text-lg-h4 text-xl-h4 primary-text"
          >
            {{ title }} Materias Cursando Actual
          </div>

          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">
                    Materia
                  </th>
                  <th class="text-left">
                    Parcial 1
                  </th>
                  <th class="text-left">
                    Parcial 2
                  </th>
                  <th class="text-left">
                    Recuperatorio
                  </th>
                  <th class="text-left">
                    Examen Final
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="notaData in materias" :key="notaData.materia_id">
                  <td>{{ notaData.materiaName }}</td>
                  <td>
                    {{ notaData.parcial1 ?? "no aplica" }}
                  </td>

                  <td>
                    {{ notaData.parcial2 ?? "no aplica" }}
                  </td>

                  <td>
                    {{ notaData.recuperatorio ?? "no aplica" }}
                  </td>

                  <td>
                    {{
                      notaData.nota || notaData.nota_equivalencia || "no aplica"
                    }}
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>

        <div v-for="(curso, indexCurso) in notas" :key="indexCurso">
          <div
            class="text-xs-h4 text-sm-h4 text-md-h4 text-lg-h4 text-xl-h4 primary-text"
          >
            {{ title }} {{ indexCurso }}
          </div>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">
                    Materia
                  </th>
                  <th class="text-left">
                    Parcial 1
                  </th>
                  <th class="text-left">
                    Parcial 2
                  </th>
                  <th class="text-left">
                    Recuperatorio
                  </th>
                  <th class="text-left">
                    Examen Final
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="notaData in curso" :key="notaData.id_materia">
                  <td>{{ notaData.nombre_materia }}</td>
                  <td>
                    {{ notaData.parcial1 ?? "no aplica" }}
                  </td>

                  <td>
                    {{ notaData.parcial2 ?? "no aplica" }}
                  </td>

                  <td>
                    {{ notaData.recuperatorio ?? "no aplica" }}
                  </td>

                  <td>
                    {{ notaData.estado_final }}
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
      </v-col>
    </CardIeaAppMain>
  </div>
</template>

<script>
// import CardIeaApp from "../../components/CardIeaApp";
import CardIeaAppMain from "../../components/CardIeaAppMain";

export default {
  name: "Nota",
  components: {
    // CardIeaApp,
    CardIeaAppMain
  },

  data: () => ({
    title: "Notas",
    notas: [],
    materias: []
  }),

  mounted() {
    this.getMaterias();
    if (
      this.$store.getters.user.borrado == 1 ||
      this.$store.getters.user.alumno_mora == true ||
      this.$store.getters.user.excedente
    ) {
      this.$router.push({
        name: "Home"
      });
    }
    this.$API
      .get({
        url: "examenes/notas"
      })
      .then(res => {
        this.notas = res;
        console.log(this.notas);
      });
  },

  methods: {
    getMaterias() {
      if (
        this.$store.getters.user.borrado == 1 ||
        this.$store.getters.user.alumno_mora == true ||
        this.$store.getters.user.excedente
      ) {
        this.$router.push({
          name: "Home"
        });
      }
      this.$API
        .get({
          url: "materias",
          data: {}
        })
        .then(res => {
          console.log(res);
          this.materias = res;
        });
    }
  }
};
</script>
